import { useEffect, useRef, useState } from 'react'
import {
  OPEN_ALBUM_SELECTION_EVENT,
  OPEN_HELP_EVENT,
  OPEN_HISTORY_EVENT,
  OPEN_HOME_EVENT,
  OPEN_THEME_REVIEW_EVENT
} from './events'

export function useSettingsMenu() {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const settingsMenuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent): void {
      if (settingsMenuRef.current && !settingsMenuRef.current.contains(event.target as Node)) {
        setIsSettingsOpen(false)
      }
    }

    function handleEsc(event: KeyboardEvent): void {
      if (event.key === 'Escape') {
        setIsSettingsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEsc)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEsc)
    }
  }, [])

  return {
    isSettingsOpen,
    setIsSettingsOpen,
    settingsMenuRef
  }
}

interface InternalNavigationOptions {
  onBackToSelector: () => void
  onOpenHistory: () => void
  onOpenHelp: () => void
  onOpenThemeReview: () => void
}

export function useInternalNavigationEvents(options: InternalNavigationOptions): void {
  useEffect(() => {
    window.addEventListener(OPEN_HISTORY_EVENT, options.onOpenHistory)
    window.addEventListener(OPEN_ALBUM_SELECTION_EVENT, options.onBackToSelector)
    window.addEventListener(OPEN_HELP_EVENT, options.onOpenHelp)
    window.addEventListener(OPEN_THEME_REVIEW_EVENT, options.onOpenThemeReview)

    return () => {
      window.removeEventListener(OPEN_HISTORY_EVENT, options.onOpenHistory)
      window.removeEventListener(OPEN_ALBUM_SELECTION_EVENT, options.onBackToSelector)
      window.removeEventListener(OPEN_HELP_EVENT, options.onOpenHelp)
      window.removeEventListener(OPEN_THEME_REVIEW_EVENT, options.onOpenThemeReview)
    }
  }, [options])
}

export function dispatchOpenHomeEvent(): void {
  window.dispatchEvent(new Event(OPEN_HOME_EVENT))
}
